window.subscribers = window.subscribers || {};

function subscribe(eventName, callback) {
  if (window.subscribers[eventName] === undefined) {
    window.subscribers[eventName] = [];
  }

  window.subscribers[eventName] = [...window.subscribers[eventName], callback];

  return function unsubscribe() {
    window.subscribers[eventName] = window.subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (window.subscribers[eventName]) {
    const promises = window.subscribers[eventName]
      .map((callback) => callback(data))
    return Promise.all(promises);
  } else {
    return Promise.resolve()
  }
}

window.subscribe = window.subscribe || subscribe;
window.publish = window.publish || publish;